import { css } from "styled-components";

export const MAIN_COLOR1 = "#FDF3C2";
export const MAIN_COLOR2 = "#DD8637";
export const BASE_COLOR1 = "#C2C2C2";
export const BASE_COLOR2 = "#E5E5E5";
export const BORDER_RADIUS = css`
  @media screen and (max-width: 960px) {
    border-radius: 20px;
  }
  @media screen and (min-width: 961px) {
    border-radius: 30px;
  }
`;

export const APPEAL_CONTENT_WIDTH = css`
  @media screen and (min-width: 601px) and (max-width: 960px) {
    width: 560px;
  }
  @media screen and (min-width: 961px) and (max-width: 1440px) {
    width: 920px;
  }
  @media screen and (min-width: 1441px) and (max-width: 1920px) {
    width: 1120px;
  }
  @media screen and (min-width: 1921px) {
    width: 1280px;
  }
`;
export const ACTION_CONTENT_WIDTH = css`
  @media screen and (min-width: 961px) and (max-width: 1440px) {
    width: 920px;
  }
  @media screen and (min-width: 1441px) and (max-width: 1920px) {
    width: 1120px;
  }
  @media screen and (min-width: 1921px) {
    width: 1280px;
  }
`;
